/* Each instance owns its controls; no legacy PDP globals or fixed default SKU. */
if (!customElements.get('cb-accessory-product')) {
  customElements.define('cb-accessory-product', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const events = { signal: this.controller.signal };
      this.track = this.querySelector('.cbap__slides');
      this.slides = Array.from(this.querySelectorAll('.cbap__slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-index]'));
      this.choice = this.querySelector('[data-variant-choice]');
      this.index = 0;
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-gallery-index]');
        const step = event.target.closest('[data-gallery-step]');
        if (thumb) this.showImage(Number(thumb.dataset.galleryIndex));
        if (step) this.showImage(this.index + Number(step.dataset.galleryStep));
      }, events);
      this.track.addEventListener('scroll', () => {
        if (this.track.clientWidth) this.updateIndex(Math.round(this.track.scrollLeft / this.track.clientWidth));
      }, { ...events, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        this.showImage(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, events);
      this.choice.addEventListener('change', () => this.syncVariant(true), events);
      this.querySelector('form').addEventListener('submit', (event) => {
        if (this.choice.selectedOptions[0]?.dataset.available !== 'true') event.preventDefault();
      }, events);
      window.addEventListener('pageshow', () => this.syncVariant(false), events);
      this.resizeObserver = new ResizeObserver(() => this.showImage(this.index));
      this.resizeObserver.observe(this.track);
      this.syncVariant(false);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
    updateIndex(index) {
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === this.index)));
      const counter = this.querySelector('[data-gallery-count]');
      if (counter) counter.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    showImage(index) {
      if (!this.slides.length) return;
      const next = (index + this.slides.length) % this.slides.length;
      this.updateIndex(next);
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: 'instant' });
    }
    syncVariant(updateUrl) {
      const selected = this.choice.selectedOptions[0];
      if (!selected) return;
      const available = selected.dataset.available === 'true';
      this.querySelector('[data-price]').textContent = selected.dataset.price;
      const compare = this.querySelector('[data-compare-price]');
      compare.textContent = selected.dataset.comparePrice || '';
      compare.hidden = !selected.dataset.comparePrice;
      this.querySelector('.cbap__sku [data-sku]').textContent = selected.dataset.sku || '—';
      this.querySelector('.cbap__submit').disabled = !available;
      this.querySelector('[data-button-label]').textContent = available
        ? `${this.dataset.addLabel} — ${selected.dataset.price}` : this.dataset.soldLabel;
      const imageIndex = this.slides.findIndex(slide => slide.dataset.imageId === selected.dataset.imageId);
      if (imageIndex >= 0) this.showImage(imageIndex);
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        window.history.replaceState(window.history.state, '', url);
      }
    }
  });
}
